var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6514 5.37849C11.4905 5.37849 12.1708 6.05877 12.1708 6.89795H12.6014C12.6014 5.82097 11.7283 4.94792 10.6514 4.94792H9.23775C8.96033 4.94792 8.73542 4.72301 8.73542 4.44558V3.03198C8.73542 1.95501 7.86237 1.08195 6.78542 1.08195H6.50684V1.51252H6.78542C7.62457 1.51252 8.30485 2.1928 8.30485 3.03198V4.44558C8.30485 4.96081 8.72253 5.37849 9.23775 5.37849H10.6514Z",
    fill: "#F47A36",
    stroke: "#F47A36",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.23487 14.7027C1.23487 14.8216 1.33125 14.918 1.45015 14.918H11.6688C12.1841 14.918 12.6017 14.5004 12.6017 13.9851V6.44316C12.6017 5.56683 12.2535 4.72614 11.6339 4.10649L9.57747 2.05008C8.95782 1.43044 8.11712 1.08225 7.2408 1.08225H2.11699C1.60164 1.08225 1.18408 1.49985 1.18408 2.01516V14.5687C1.18408 14.6876 1.28047 14.784 1.39937 14.784C1.51827 14.784 1.61465 14.6876 1.61465 14.5687V2.01516C1.61465 1.73764 1.83945 1.51282 2.11699 1.51282H7.2408C8.00294 1.51282 8.73412 1.81566 9.273 2.35454L11.3294 4.41095C11.8683 4.94984 12.1711 5.68102 12.1711 6.44316V13.9851C12.1711 14.2626 11.9463 14.4874 11.6688 14.4874H1.45015C1.33125 14.4874 1.23487 14.5838 1.23487 14.7027Z",
    fill: "#F47A36",
    stroke: "#F47A36",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44043 8.21587C5.44043 8.33477 5.51446 8.43115 5.60578 8.43115H10.0633C10.1547 8.43115 10.2287 8.33477 10.2287 8.21587C10.2287 8.09697 10.1547 8.00058 10.0633 8.00058H5.60578C5.51446 8.00058 5.44043 8.09697 5.44043 8.21587Z",
    fill: "#F47A36",
    stroke: "#F47A36",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44092 10.9053C5.44092 11.0242 5.50061 11.1206 5.57425 11.1206H10.0968C10.1704 11.1206 10.2301 11.0242 10.2301 10.9053C10.2301 10.7864 10.1704 10.69 10.0968 10.69H5.57425C5.50061 10.69 5.44092 10.7864 5.44092 10.9053Z",
    fill: "#F47A36",
    stroke: "#F47A36",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelex);
export default __webpack_public_path__ + "static/media/telex.4e60847973f7ce39a3c93c33de5e5861.svg";
export { ForwardRef as ReactComponent };